import { translate } from '#src/utils/i18n/translate';

declare global {
  interface Window {
    Drupal: {
      t: (key: string) => string;
    };
  }
}

export function useI18n() {
  return {
    t: translate,
  };
}
